export default __webpack_public_path__ + "static/media/plus_black_2.75127cf8.svg";